import axios from "axios";
import { backUrl } from "../Urls";
import { setupApiInterceptor } from "../interceptor";

const SdkApi = axios.create({
  baseURL: backUrl + "/",
  timeout: 60000,
});

setupApiInterceptor(SdkApi, "sdk");

export default SdkApi;
